import { getListExecutorApi, inactiveExecutorApi, 
    sendSmsPaymentByExe, updateSignatureAttachExecutor, upsertExecutorApi } from 'helpers/backend_helper';
import {takeEvery,put,call} from 'redux-saga/effects';
import { getFileCommonReset } from 'store/actions';
import { getListExecutorFail, getListExecutorSuccess, inactiveExecutorFail, inactiveExecutorSuccess, sendSmsPaymentFail, sendSmsPaymentSuccess, updateSignatureExecutorFail, updateSignatureExecutorSuccess, upsertExecutorFail, upsertExecutorSuccess } from './actions';
import { GET_LIST_EXECUTOR, INACTIVE_EXECUTOR, SEND_SMS_PAYMENT, UPDATE_SIGNATURE_EXECUTOR, UPSERT_EXECUTOR } from './actionTypes';

function* onUpdateSignature({payload:attach}){
    try {
       const response = yield call(updateSignatureAttachExecutor,attach)

       yield put(updateSignatureExecutorSuccess(response))
       yield put (getFileCommonReset())
    } catch (error) {
        yield put(updateSignatureExecutorFail(error))
    }
}

function* onSendSmsPayment({payload:events}){
    try {
      var result = yield call(sendSmsPaymentByExe,events)
       if(result === 'success') {
        yield put (sendSmsPaymentSuccess())
       }
       else{
        yield put(sendSmsPaymentFail('خطای ارسال پیام به مالک'))
       }
    } catch (error) {
        yield put(sendSmsPaymentFail(error))
    }
}

function* onGetListExecutor(){
    try
    {

       const result = yield call(getListExecutorApi)

        yield put (getListExecutorSuccess(result))

    } catch (error) {
        yield put(getListExecutorFail(error))
    }
}

function* onInactiveExecutor({ payload: data }) {
    try {
      yield call(inactiveExecutorApi,data)
      yield put(inactiveExecutorSuccess({id:data.exeId,inactive:data.inactive,des:data.des}))
    } catch (error) {
      yield put(inactiveExecutorFail(error))
    }
  }

  function*  onUpsertExecutor({payload:data}){
    try {
        yield call( upsertExecutorApi,data)
        yield put(upsertExecutorSuccess("مجری آپدیت شد"))
        const result = yield call(getListExecutorApi)
        yield put (getListExecutorSuccess(result))
    } catch (error) {
        yield put(upsertExecutorFail(error))
    }
}

function* saga(){
    yield takeEvery(UPDATE_SIGNATURE_EXECUTOR,onUpdateSignature)
    yield takeEvery(SEND_SMS_PAYMENT,onSendSmsPayment)
    yield takeEvery(GET_LIST_EXECUTOR,onGetListExecutor)
    yield takeEvery(INACTIVE_EXECUTOR,onInactiveExecutor)
    yield takeEvery(UPSERT_EXECUTOR,onUpsertExecutor)
}

export default saga;
